<script setup lang="ts">
import HeaderResult from '~/components/layouts/HeaderResult.vue'
import { useResultStore } from '~/store/result'
import { useAppTour } from '~/composables/useAppTour'
import { useAuthStore } from '~/store/auth'

const NewFooter = defineAsyncComponent(() => import('~/components/layouts/NewFooter.vue'))
const ModalWelcome = defineAsyncComponent(() => import('~/components/pages/results/modals/ModalWelcome.vue'))
const ModalSignUp = defineAsyncComponent(() => import('~/components/modals/ModalSignUp.vue'))
const ModalLogin = defineAsyncComponent(() => import('~/components/modals/ModalLogin.vue'))
const ModalVerifyEmail = defineAsyncComponent(() => import('~/components/modals/ModalVerifyEmail.vue'))

const route = useRoute()
const resultStore = useResultStore()
const authStore = useAuthStore()
const { tour, initTour } = useAppTour()
const { locale } = useI18n()

const startTour = async () => {
	const p = route.path.replace(/\/+$/, '')

	const isRoot = p === '' || p === '/' || p === `/${locale.value}`

	if (isRoot) return

	await nextTick()
	await initTour()
	tour.start()
}
</script>

<template>
	<main>
		<HeaderResult />
		<slot />
		<NewFooter />
		<ModalWelcome
			v-model="resultStore.showModalWelcome"
			@start-tour="startTour"
		/>
		<ModalSignUp v-model="authStore.showModalSignUp" />
		<ModalLogin v-model="authStore.showModalLogin" />
		<ModalVerifyEmail v-model="authStore.showModalVerifyEmail" />
	</main>
</template>
